import React from "react";
import { Link } from "react-router-dom";
import { Lock, Check, ChevronRight } from "lucide-react";

export default function StepCard({ step, progress }) {
  const completed = progress?.exercises_completed || [];
  const total = 4;
  const pct = Math.round((completed.length / total) * 100);
  const locked = step.step > 1 && !progress?.previousComplete;

  const inner = (
    <div className={`relative overflow-hidden rounded-3xl border p-6 transition-all ${
      locked
        ? "border-white/5 bg-white/[0.015] opacity-60"
        : "bps-card hover:-translate-y-1 hover:shadow-[0_28px_60px_rgba(34,211,238,0.18)]"
    }`}>
      {/* Number sigil */}
      <div className="absolute -right-2 -top-4 select-none pointer-events-none font-display font-extrabold text-[110px] leading-none" style={{
        color: "transparent",
        WebkitTextStroke: `1px ${locked ? "rgba(255,255,255,0.06)" : "rgba(34,211,238,0.18)"}`,
      }}>
        0{step.step}
      </div>

      {/* Accent corner glow */}
      {!locked && (
        <div className="absolute -top-16 -right-16 w-44 h-44 rounded-full opacity-50" style={{
          background: `radial-gradient(circle, ${step.accent}55, transparent 70%)`,
        }} />
      )}

      <div className="flex items-start justify-between relative">
        <div>
          <div className="bps-eyebrow mb-2" style={{ color: step.accent }}>Week {step.step}</div>
          <h3 className="font-display text-2xl font-medium tracking-tight">{step.title}</h3>
          <p className="text-sm text-[#9AAEC6] mt-1">{step.subtitle}</p>
        </div>
        <div className="ml-3 relative z-10">
          {locked ? (
            <div className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center"><Lock size={16} className="text-[#7C8FA8]" strokeWidth={1.6} /></div>
          ) : progress?.is_complete ? (
            <div className="w-10 h-10 rounded-full bg-[#10B981] flex items-center justify-center" style={{ boxShadow: "0 0 24px rgba(16,185,129,0.5)" }}><Check size={18} className="text-white" strokeWidth={2.2} /></div>
          ) : (
            <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{
              background: "linear-gradient(180deg, #2BE3FF, #0AB7D6)",
              boxShadow: "0 0 18px rgba(34,211,238,0.5)",
            }}><ChevronRight size={18} className="text-[#03101F]" strokeWidth={2.2} /></div>
          )}
        </div>
      </div>

      <p className="text-sm text-white/70 mt-4 italic relative">"{step.shift}"</p>

      <div className="mt-5 flex items-center gap-3 relative">
        <div className="flex-1 h-1.5 bg-white/5 rounded-full overflow-hidden">
          <div className="h-full transition-all duration-700" style={{
            width: `${pct}%`,
            background: `linear-gradient(90deg, ${step.accent}, ${step.accent}CC)`,
            boxShadow: `0 0 12px ${step.accent}88`,
          }} />
        </div>
        <div className="text-[11px] text-[#7C8FA8] font-mono">{completed.length}/{total}</div>
      </div>
    </div>
  );

  if (locked) return <div data-testid={`step-card-${step.step}-locked`}>{inner}</div>;
  return (
    <Link to={`/journey/${step.step}`} data-testid={`step-card-${step.step}`}>{inner}</Link>
  );
}
